import { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Link } from 'src/components/Link';
import { Typography } from 'src/components/Typography';

type DisclosureKeyPrefix = 'notifications' | 'profileLayout';

interface SmsOptInCheckoutStyleFinePrintProps {
  brand?: string | null;
  disclosureKeyPrefix: DisclosureKeyPrefix;
  sx?: SxProps<Theme>;
}

/**
 * Matches v3 checkout user-info SMS block: transactional disclosure plus
 * Terms of Service and Privacy Policy links (Twilio / compliance).
 */
export const SmsOptInCheckoutStyleFinePrint = ({
  brand,
  disclosureKeyPrefix,
  sx,
}: SmsOptInCheckoutStyleFinePrintProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: disclosureKeyPrefix,
  });
  const { t: tPhone } = useTranslation('translation', {
    keyPrefix: 'phoneConsent',
  });

  const brandName = brand || 'Exercise.com';

  return (
    <Box sx={sx}>
      <Typography variant="body2" color="text.secondary" component="span">
        {t('smsOptInDisclosure', { brand: brandName })}{' '}
        {tPhone('seeOur')}{' '}
        <Link
          href="/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          sx={{ typography: 'body2' }}
        >
          {tPhone('termsOfService')}
        </Link>{' '}
        {tPhone('and')}{' '}
        <Link
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          sx={{ typography: 'body2' }}
        >
          {tPhone('privacyPolicy')}
        </Link>
        .
      </Typography>
    </Box>
  );
};
